module.exports = __webpack_public_path__ + "img/sale-button-01.86921da0.png";